/**
 * i18n helper for common/shared translations
 * Provides locale-aware fallbacks to prevent RO/EN mixing
 */

type Locale = 'ro' | 'en';

interface FallbackMap {
  [key: string]: {
    ro: string;
    en: string;
  };
}

const fallbacks: FallbackMap = {
  'common.loading': {
    ro: 'Se încarcă...',
    en: 'Loading...',
  },
  'common.error': {
    ro: 'Ceva nu a mers bine',
    en: 'Something went wrong',
  },
  'common.back': {
    ro: 'Înapoi',
    en: 'Back',
  },
  'auth.invalidCredentials': {
    ro: 'Email sau parolă incorectă. Te rugăm să verifici datele și să încerci din nou.',
    en: 'Invalid email or password. Please check your credentials and try again.',
  },
};

/**
 * Get locale-aware fallback for a translation key
 * @param key - Translation key
 * @param locale - Current locale ('ro' | 'en')
 * @returns Fallback string matching the locale, or the key if not found
 */
export function getCommonFallback(key: string, locale: Locale): string {
  const fallback = fallbacks[key];
  if (!fallback) {
    return key; // Return key as last resort
  }
  return fallback[locale] || fallback.ro; // Default to RO if locale not found
}

/**
 * Common i18n helper object
 */
export const commonI18n = {
  get: getCommonFallback,
};

